import { BorderRight } from "@mui/icons-material";
import { LuSearch ,LuChevronDown} from "@/Components/Icons/Icons";
export default {
  row1 : [
    {
      column: "column1",
      columnWidth: "50%",
      rows: {
        row1: [
          {
            name: "isftAbenefitsclaimed",
            checkboxLabel: "FTA Benefits Claimed",
            component: "checkboxBox",
          },
        ],
        row2: [
            {
              name:"Particulars of Certificate of Origin",
              component:"header",

            },
          ],

          row3: [
            {
              name: "ftacoOno",
              label: "COO No",
              component: "text-field",
              icon: LuSearch,  
              dependsOn : "isftAbenefitsclaimed",          
            },
          
            
          ],

          row4: [
            {
          name: "ftAdateofissue",
          label:"Date Of Issue",
          component: "DateSelector",
          dependsOn : "isftAbenefitsclaimed",
        }
          ],
          row5: [
            {
              name: "ftAissuingcountry",
              label: "Issuing Country",
              component: "text-field",
              icon: LuSearch,
              type : "autocomplete",
              endpoint : "getCountry",
              dependsOn : "isftAbenefitsclaimed",
            },
          
            
          ],
          row6: [
            {
              name: "ftAorigincriteria",
              label:"Origin Criteria",
              component: "dropdown",
              endIconName: LuChevronDown,
              iconColor: "gray-400", 
              dependsOn : "isftAbenefitsclaimed",
              options: [
                {
                  label: "COWO - wholly Obtained",
                  value: "COWO - wholly Obtained",
                },
                {
                  label: "CONWO - COOG - Others(General Rules)",
                  value: "CONWO - COOP - Others(General Rules)",
                },
                {
                  label: "CONWO - COOP - Others(Product Specific Rules)",
                  value: "CONWO - COOP - Others(Product Specific Rules)",
                },
              ]
                      
            },
          ],
          row7: [
            {
              name: "ftAifothersSpecify",
              label:"If Others,specify",
              component: "text-field",
              dependsOn : "ftAorigincriteria",
              dependsValue : ["CONWO - COOP - Others(General Rules)","CONWO - COOP - Others(Product Specific Rules)"],

            },
        ],
        row8: [
            {
              name: "ftAtariffshift",
              label:"Tariff Shift",
              component: "dropdown",
              endIconName: LuChevronDown,
              iconColor: "gray-400", 
              dependsOn : "ftAorigincriteria",
              dependsValue : ["CONWO - COOP - Others(General Rules)","CONWO - COOP - Others(Product Specific Rules)"],
              options : [
                {
                  label: "CC",
                  value: "CC",
                },
                {
                  label: "CTH",
                  value: "CTH",
                },
                 {
                  label: "NA",
                  value: "NA",
                },
                 {
                  label: "CTS",
                  value: "CTS",
                }
              ]
  
                      
            },
          ],
          row9: [
            {
              name: "ftAaccumulation",
              label:"Accumulation/Cumulation",
              component: "dropdown",
              endIconName: LuChevronDown,
              iconColor: "gray-400", 
              dependsOn : "isftAbenefitsclaimed",
              options : [
                {
                  label: "Yes",
                  value: "Yes",
                },
                {
                  label: "No",
                  value: "No",
                },
              ]
  
                      
            },
          ],
          row10: [
            {
              name: "ftAretroactiveissuance",
              label:"Retroactive Issuance",
              component: "dropdown",
              endIconName: LuChevronDown,
              iconColor: "gray-400", 
              dependsOn : "isftAbenefitsclaimed",
              options : [
                {
                  label: "Yes",
                  value: "Yes",
                },
                {
                  label: "No",
                  value: "No",
                },
              ]
  
                      
            },
          ],
          row11: [
            {
              name: "ftAdirectconsignment",
              label:"Direct Consignment",
              component: "dropdown",
              endIconName: LuChevronDown,
              iconColor: "gray-400", 
              dependsOn : "isftAbenefitsclaimed",
              options : [
                {
                  label: "Yes",
                  value: "Yes",
                },
                {
                  label: "No",
                  value: "No",
                },
              ]
  
                      
            },
          ],
          row12: [
            {
              name: "ftAitemSrNoInCertificate",
              label:"Item Sr No In certifiacte",
              component: "text-field",
              dependsOn : "isftAbenefitsclaimed"        
            },
        ],

    }
}
]
}